export default __webpack_public_path__ + "media/images/users/user-patrick-pool-170x170-7f5eec332e47f653751eedc3f7e8e856.jpg";